import { createColumnHelper } from '@tanstack/react-table';
import { Translation } from 'react-i18next';

import { IFermentation } from '@/features/fermentation/types/fermentation';

const columnHelper = createColumnHelper<IFermentation>();

export const selectionColumns = [
  columnHelper.accessor('name', {
    header: () => <Translation>{(t) => <>{t('measurements.name')}</>}</Translation>,
  }),

  columnHelper.accessor('createdAt', {
    header: () => <Translation>{(t) => <>{t('measurements.startDate')}</>}</Translation>,
    cell: (props) => props.getValue().toLocaleDateString('de-DE'),
  }),

  columnHelper.accessor('batchCount', {
    header: () => (
      <Translation>{(t) => <>{t('fermentations.numOfAnalysis')}</>}</Translation>
    ),
    cell: (props) => props.getValue(),
  }),
];
